import { kanbify } from '../lib/kanbifyClient'

/* ========== CARD MEMBERS ========== */
export async function addCardMember(cardId, userId, { cardTitle, senderName, actorId } = {}) {
    const { error } = await kanbify.from('card_members').insert([{ card_id: cardId, user_id: userId }])
    if (!error && cardTitle) {
        // Trimite notificare email asincron (fire and forget)
        const { data: profile } = await kanbify.from('profiles').select('email, full_name').eq('id', userId).single()
        if (profile?.email) {
            kanbify.functions.invoke('send-notification', {
                body: {
                    type: 'card_assigned',
                    recipientId: userId,
                    recipientEmail: profile.email,
                    recipientName: profile.full_name,
                    actorId,
                    cardTitle,
                    cardId,
                    senderName,
                },
            }).catch(() => { /* notificarea email e opțională */ })
        }
    }
    return { error }
}

// Notify a card's stakeholders (creator + co-members, minus the actor) that it
// was completed. Best-effort fire-and-forget — mirrors addCardMember's
// send-notification call. The shim's send-notification creates the in-app
// notification row from recipientId (the bell reads by user_id) and emails
// when an address resolves; a 30s server-side dedup collapses repeats.
export async function notifyCardCompleted({ cardId, cardTitle, recipientIds = [], actorId, senderName } = {}) {
    const targets = [...new Set((recipientIds || []).filter(Boolean))].filter((id) => id !== actorId)
    for (const recipientId of targets) {
        try {
            const { data: profile } = await kanbify
                .from('profiles')
                .select('email, full_name')
                .eq('id', recipientId)
                .single()
            kanbify.functions.invoke('send-notification', {
                body: {
                    type: 'task_completed',
                    recipientId,
                    recipientEmail: profile?.email,
                    recipientName: profile?.full_name,
                    actorId,
                    cardTitle,
                    cardId,
                    senderName,
                },
            }).catch(() => { /* best-effort */ })
        } catch { /* best-effort */ }
    }
}

export async function removeCardMember(cardId, userId) {
    const { error } = await kanbify.from('card_members').delete().eq('card_id', cardId).eq('user_id', userId)
    return { error }
}
